import ShareWrapper from '../src/LikingPhotos/ShareWrapper';
export default ShareWrapper;
